<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#">{{translations('navbar.goods_receipt_issue_detail')}}</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">{{translations('navbar.goods_receipt_issue_detail')}}</li>
      </ol>
    </nav>
    <div class="container-fluid main-container">
      <div class="form-inline mb-4 d-flex justify-content-between flex-nowrap">
        <div class="d-flex flex-wrap w-100">
          <div class="form-group search-in-out mr-3 min-width-300">
            <InOutSearch v-model="searchProduct"/>
          </div>
          <div class="form-group mr-3">
            <div class="dropdown">
              <button id='filterByClient' class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ selectWarehouseName }}
                </button>
              <div class="dropdown-menu">
                <a class='dropdown-item' v-for='(item, i) in master_mywarehouses' :key='i' v-on:click='warehouseId=item.id'>{{ item.name }}</a>
              </div>
            </div>
          </div>
          <div class="form-group mr-3 d-flex flex-wrap">
            <span class="mr-1">{{translations('common.period')}}</span>
<!--            <input v-model="dateFrom" type="date" class="form-control" @blur='triggerDateFilter("dateFrom")' @focus="tempDateField = dateFrom">-->
            <input v-model="dateFrom" type="date" class="form-control">
            <span class="mr-1 ml-1">〜</span>
<!--            <input v-model="dateTo" type="date" class="form-control" @blur='triggerDateFilter("dateTo")' @focus="tempDateField = dateTo">-->
            <input v-model="dateTo" type="date" class="form-control">
          </div>
          <div class="form-group mr-2" v-for="(condition, i) in conditions" :key='i'>
            <div class="form-check">
              <input class="form-check-input pointer-clickable" type="radio" :value="condition.value" :id="'s-'+condition.id" v-model="selectedCondition">
              <label class="form-check-label pointer-clickable" :for="'s-'+condition.id">
                {{condition.name}}
              </label>
            </div>
          </div>
          <div class="form-group">
            <button class="btn btn-primary btn-sm" type="button" @click="submitSearch">{{translations('common.search')}}</button>
          </div>
        </div>
      </div>

      <div class="table-scroll mb-4">
        <v-data-table
          class="table table-striped table-hover"
          item-key="name"
          :headers="[
            { text: translations('inventory.date'), value: 'date' },
            { text: translations('inventory.division'), value: 'type', sortable: false },
            { text: 'From', value: 'from_name', sortable: false },
            { text: 'To', value: 'to_name', sortable: false },
            { text: 'To2', value: 'to2', sortable: false },
            { text: translations('inventory.number_acceptance'), value: 'in_quantity', sortable: false },
            { text: translations('inventory.number_payout'), value: 'out_quantity', sortable: false },
            { text: translations('inventory.quantity_stock'), sortable: false },
            { text: translations('inventory.selling_price'), value: 'unit_price', sortable: false },
            { text: translations('inventory.cost_price'), value:'origin_price', sortable: false},
            { text: translations('inventory.order_number'), value: 'in_order_number', sortable: false },
            { text: translations('inventory.client_order_number'), value: 'out_order_number', sortable: false },
            { text: translations('inventory.summary'), value: 'description', sortable: false },
            { text: translations('inventory.processing_person_name'), value: 'user_edit', sortable: false }
          ]"
          :items="convertDetails"
          :options.sync="options"
          :server-items-length="totalCount"
          hide-default-footer
          @page-count="pageCount = $event"
        >
          <template v-slot:body="{ items }">
            <tbody class="nowrap">
              <template v-if="!isEmpty">
                <tr  v-for="(item, i) in items" :key='i' data-href="">
                  <td>{{ item.date }}</td>
                  <td>{{ item.type }}</td>
                  <td>{{ item.from_name }}</td>
                  <td>{{ item.to_name }}</td>
                  <td>{{ item.to2 }}</td>
                  <td>{{ item.in_quantity ? Number(item.in_quantity).toLocaleString() : '' }}</td>
                  <td>{{ item.out_quantity ? Number(item.out_quantity).toLocaleString() : '' }}</td>
                  <td>
                    <template  v-if="isLoadingQuantity(item)">
                      <v-progress-circular indeterminate size="16" width="1">
                      </v-progress-circular>
                    </template>
                    <div v-else>{{ item.quantity_stock }}</div>
                  </td>
                  <td>{{ item.unit_price }}</td>
                  <td><template v-if="originPrice === -1">
                      <v-progress-circular indeterminate size="16" width="1">
                      </v-progress-circular>
                    </template>
                    <div v-else>{{ item.origin_price }}</div>
                  </td>
                  <td>{{ item.in_order_number }}</td>
                  <td>{{ item.out_order_number }}</td>
                  <td>{{ item.description }}</td>
                  <td>{{ item.user_edit }}</td>
                </tr>
              </template>
              <template v-else>
                <tr class="odd" v-if="isZeroWareHouse">
                  <td valign="top" colspan="12" class="dataTables_empty">{{ isEmptyMsg }}</td>
                </tr>
              </template>
            </tbody>
          </template>
        </v-data-table>
      </div>
      <v-pagination v-model="page" :length="pageCount" :total-visible="11"></v-pagination>
    </div>
    <vue-element-loading :active="isSearching" :is-full-screen="true"/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import InOutSearch from '@/components/InOutSearch'
import { mapState } from 'vuex'

export default {
  name: 'InoutDetails',
  props: {},
  components: {
    VueElementLoading,
    InOutSearch
  },
  watch: {
    page () {
      this.getFilterdList()
    },
    options: {
      handler () {
        this.initList()
      },
      deep: true
    }
    // warehouseId (newVal) {
    //   if (newVal) {
    //     this.initList()
    //   }
    // }
    // searchProduct (newVal) {
    //   if (newVal) {
    //     this.initList()
    //   }
    // }
  },
  data () {
    return {
      searchProduct: this.$storage.get('InOutSearch:searchProduct') || '',
      isSearching: false,
      warehouseId: 0,
      originPrice: -1,
      details: [],
      stockQuantities: {},
      stockDisassamblyQuantities: {},
      productId: null,
      isEmpty: false,
      isEmptyMsg: '',
      isZeroWareHouse: true,
      dateFrom: this.$invoiceTools.getCurrentDate(),
      dateTo: this.$invoiceTools.getCurrentDate(),
      // tempDateField: '',
      page: 1,
      pageCount: 0,
      totalCount: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
      },
      conditions: [],
      selectedCondition: 0
    }
  },
  created: async function () {
    this.conditions = [
      { id: 'good', name: this.translations('inventory.good'), value: 0 },
      { id: 'bad', name: this.translations('inventory.bad'), value: 1 },
      { id: 'outlet', name: this.translations('inventory.outlet'), value: 2 }
    ]
    this.$store.dispatch('Master/checkMywarehouses')

    let storedFilter = this.$storage.get('InoutDetailsParam')
    if (storedFilter) {
      this.selectedCondition = storedFilter.condition
      this.dateFrom = storedFilter.start_at
      this.dateTo = storedFilter.end_at
      this.warehouseId = parseInt(storedFilter.warehouse_id)
    }
  },
  computed: {
    ...mapState(['currentLanguage']),
    master_mywarehouses () {
      return this.$store.getters['Master/getMywarehouses']
    },
    selectWarehouseName () {
      const warehouse = this.master_mywarehouses.find(w => w.id === this.warehouseId)
      return warehouse ? warehouse.name : this.translations('inventory.warehouse_selection')
    },
    convertDetails () {
      return this.details.map((item, i) => {
        let quantityStock = ''
        quantityStock = Number(this.stockQuantities[item.date] || 0).toLocaleString()
        if (this.showQuantity(this.details, item, i)) {
          quantityStock = Number(this.stockQuantities[`${item.date}-${item.type}`] || 0).toLocaleString()
        } else if (this.showQuantityDisassemble(item)) {
          quantityStock = Number((this.stockDisassamblyQuantities[item.date] && this.stockDisassamblyQuantities[item.date][item.to_name]) || 0).toLocaleString()
        }
        if (this.originPrice > -1) {
          item.origin_price = this.originPrice
        }
        item.quantity_stock = quantityStock
        return item
      })
    }
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    initList () {
      if (this.page !== 1) {
        this.page = 1
      } else {
        this.getFilterdList()
      }
    },
    // triggerDateFilter (source) {
    //   if (source === 'dateFrom' && this.dateFrom !== this.tempDateField) {
    //     this.initList()
    //   }
    //
    //   if (source === 'dateTo' && this.dateTo !== this.tempDateField) {
    //     this.initList()
    //   }
    // },
    getFilterdList () {
      if (this.isSearching || !this.searchProduct || !this.dateFrom || !this.dateTo) {
        return
      }

      this.isSearching = true

      const offset = (this.page - 1) * this.options.itemsPerPage
      const limit = this.options.itemsPerPage
      const orderbys = JSON.parse(JSON.stringify(this.options.sortBy))
      const isDescs = JSON.parse(JSON.stringify(this.options.sortDesc))

      const params = {
        search_product: this.searchProduct,
        warehouse_id: this.warehouseId,
        start_at: this.dateFrom,
        end_at: this.dateTo,
        offset: offset,
        limit: limit,
        orderbys: orderbys,
        is_descs: isDescs,
        condition: this.selectedCondition
      }

      console.log(params)
      this.$storage.set('InoutDetailsParam', params)
      if (params.warehouse_id === 0) {
        this.isZeroWareHouse = false
        this.isEmptyMsg = '倉庫を選択してください'
        this.$toastr.error(this.isEmptyMsg)
      } else {
        this.isZeroWareHouse = true
      }

      console.log('InoutDetails:getFilterdList: ', params)
      this.$http.post(this.$api_url.inventory_inout, params).then(async response => {
        const result = response.data
        if (result.status === true) {
          this.isEmpty = result.list.length === 0
          this.isEmptyMsg = result.list.length === 0 ? this.translations('inventory.data_not_found') : ''
          this.details = result.list
          this.productId = Number(result.product_id)
          this.totalCount = Number(result.total_count)

          if (result.list.length > 0) {
            await this.getStockQuantity()
            this.getStockQuantityDisassembly()
            this.getOriginPrices()
            this.getSingleStockQuantity()
          }
        } else {
          this.details = []
          this.$toastr.error(result.message, 'エラー')
        }
      }).catch(e => {
        console.log('InoutDetails:API:getFilterdList: error: ', e)
        this.isEmpty = true
        this.isEmptyMsg = 'エラーのため失敗しました。ご確認後、再試行してください。'
        this.$toastr.error(this.isEmptyMsg, 'エラー')
      }).finally(() => {
        this.isSearching = false
        this.$nextTick(() => {
          this.$vuetify.goTo('.table-scroll', { duration: 0 })
        })
      })
    },
    getStockQuantity () {
      this.stockQuantities = {}
      let dates = this.details
        .filter(e => e.type !== '分解')
        .map(d => {
          return d.date
        })
      // 重複削除
      dates = Array.from(new Set(dates))

      const params = {
        product_id: this.productId,
        warehouse_id: this.warehouseId,
        dates: dates,
        condition: this.selectedCondition
      }
      return this.$http.post(this.$api_url.inventory_quantity, params).then(response => {
        const result = response.data
        if (result.status === true) {
          this.stockQuantities = result.list
        } else {
          this.$toastr.error(result.message, 'エラー')
        }
      }).catch(e => {
        console.log('InoutDetails:API:getStockQuantity: error: ', e)
        this.$toastr.error(this.isEmptyMsg, 'エラー')
      }).finally(() => {
      })
    },
    getSingleStockQuantity () {
      try {
        this.details
          .filter(e => (e.type.includes('parent') || e.type === '棚卸し'))
          .map(inventory => this.getSingleStockQuantityAsync(inventory))
      } catch (error) {}
    },
    async getSingleStockQuantityAsync (inventory) {
      try {
        const params = {
          product_id: this.productId,
          warehouse_id: this.warehouseId,
          date: inventory.date,
          condition: this.selectedCondition,
          type: inventory.type
        }
        const { data: { status, data } } = await this.$http.post(this.$api_url.inventory_quantity_single, params)
        if (status) {
          this.$set(this.stockQuantities, `${inventory.date}-${inventory.type}`, data)
        }
      } catch (error) {}
    },
    getStockQuantityDisassembly () {
      this.stockDisassamblyQuantities = {}
      let haveDisassembly = 0
      let dates = this.details.reduce((value, item) => {
        if (item.type === '分解') {
          haveDisassembly = 1
          if (!value[item.date]) value[item.date] = []
          value[item.date].push(item.to_name)
        }
        return value
      }, {})
      if (!haveDisassembly) return
      const params = {
        product_id: this.productId,
        warehouse_id: this.warehouseId,
        dates: dates,
        condition: this.selectedCondition
      }
      this.$http.post(this.$api_url.inventory_quantity_disassembly, params).then(response => {
        const result = response.data
        if (result.status === true) {
          this.stockDisassamblyQuantities = result.list
        } else {
          this.$toastr.error(result.message, 'エラー')
        }
      }).catch(e => {
        console.log('InoutDetails:API:getStockQuantity: error: ', e)
        this.$toastr.error(this.isEmptyMsg, 'エラー')
      }).finally(() => {
      })
    },
    getOriginPrices () {
      this.originPrice = -1
      const params = {
        product_id: this.productId
      }
      this.$http.post(this.$api_url.inventory_origin_price_product, params).then(response => {
        const result = response.data
        if (result.status === true) {
          this.originPrice = result.data.original_price_jpy
        } else {
          this.$toastr.error(result.message, 'エラー')
        }
      }).catch(e => {
        console.log('InoutDetails:API:getStockQuantity: error: ', e)
        this.$toastr.error(this.isEmptyMsg, 'エラー')
      }).finally(() => {
      })
    },
    showQuantity (items, item, i) {
      return (item.type === '棚卸し' || item.type.includes('parent')) && item.type !== '分解'
    },
    showQuantityDisassemble (item) {
      return item.type === '分解'
    },
    isLoadingQuantity (item) {
      if (!item.type === '棚卸し' || !item.type.includes('parent')) return !this.stockQuantities[item.date] && item.type !== '分解'
      return (!this.stockQuantities[`${item.date}-${item.type}`] && item.type !== '分解') ||
        (!this.stockDisassamblyQuantities[item.date] && item.type === '分解')
    },
    submitSearch () {
      this.initList()
    }
  }
}
</script>

<style>
#tbl-stocks_wrapper .col-sm-12{
  padding-right: 0 !important;
}

.loader {
  text-align: center;
  color: #bbbbbb;
}
</style>
